/**
 * Visible entry points for Archive Command. The palette itself listens for
 * the "archive:command-open" window event, so triggers can live anywhere.
 */
import React from "react";
import { Terminal } from "lucide-react";

export const openCommandPalette = () =>
  window.dispatchEvent(new CustomEvent("archive:command-open"));

export const isMac = () =>
  typeof navigator !== "undefined" && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent);

export const shortcutLabel = () => (isMac() ? "⌘K" : "CTRL K");

/** Compact desktop chip — visually secondary, sits beside primary nav CTAs. */
export const CommandTrigger = ({ className = "" }) => (
  <button
    type="button"
    onClick={openCommandPalette}
    data-testid="command-trigger-desktop"
    title="Open Archive Command"
    className={`flex items-center gap-2 border border-[#2D2A26] px-2.5 py-2 font-mono text-[9px] uppercase tracking-[0.2em] text-[#757065] hover:border-[#D92D20]/60 hover:text-[#A39E93] transition-colors ${className}`}
  >
    <Terminal size={11} className="text-[#D92D20]/70" />
    <kbd className="font-mono text-[9px] tracking-[0.1em]">{shortcutLabel()}</kbd>
    <span>Command</span>
  </button>
);

/** Mobile tap target — comfortable size, lives in the mobile drawer. */
export const MobileCommandTrigger = ({ onNavigate }) => (
  <button
    type="button"
    onClick={() => { onNavigate?.(); openCommandPalette(); }}
    data-testid="command-trigger-mobile"
    className="w-full flex items-center justify-center gap-2 border border-[#D92D20]/40 px-3 py-3 font-mono text-[10px] uppercase tracking-widest text-[#C9C2B4] hover:border-[#D92D20] hover:text-[#E4DFD3] transition-colors"
  >
    <Terminal size={13} className="text-[#D92D20]" /> Command
  </button>
);
